import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button, ButtonType, getOrganisationDomain } from '../../../shared';
import { ErrorLayout } from '../ErrorLayout';

import classes from './NoAccess.module.scss';

export const NoAccess: FunctionComponent = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const homeClickHandler = () => {
    if (!window.location.href.includes(`-${getOrganisationDomain()}`)) {
      navigate('/');
      return;
    }
    const url = new URL(window.location.href);
    url.hostname = url.hostname.replace(/^([^.]+)-(.*)$/, '$2');
    window.location.replace(url.href.replace('/noAccess', ''));
  };

  return (
    <ErrorLayout subtitle={t('noAccess.title')}>
      <div className={classes['no-access']}>
        <div className={classes['no-access__message']}>{t('noAccess.message')}</div>
      </div>

      <div className={classes['no-access__buttons']}>
        <Button
          type={ButtonType.secondary}
          label={t('common.back-to-login')}
          onClick={() => navigate('/auth/login')}
        />
        <Button
          type={ButtonType.primary}
          label={t('common.back-home')}
          onClick={homeClickHandler}
        />
      </div>
    </ErrorLayout>
  );
};
